export const LEAD_STATUSES = [
    'new',
    'queued',
    'calling',
    'contacted',
    'recovered',
    'not_interested',
    'failed',
    'do_not_call',
];
export const CALL_STATUSES = [
    'queued',
    'ringing',
    'in_progress',
    'ended',
    'failed',
    'no_answer',
    'busy',
    'voicemail',
];
export const CALL_OUTCOMES = [
    'recovered',
    'callback',
    'not_interested',
    'no_answer',
    'voicemail',
    'do_not_call',
    'wrong_number',
    'other',
];
export const CAMPAIGN_STATUSES = ['draft', 'running', 'paused', 'done'];
export const CAMPAIGN_LEAD_STATUSES = [
    'pending',
    'scheduled',
    'calling',
    'done',
    'skipped',
];
export const USER_ROLES = ['super_admin', 'admin', 'operator', 'viewer'];
export const VOICE_PROVIDERS = ['retell', 'mock'];
/** Idiomas suportados para as ligações (códigos aceitos pelo Retell). */
export const CALL_LANGUAGES = [
    { code: 'pt-BR', label: 'Português (Brasil)' },
    { code: 'en-US', label: 'English (US)' },
    { code: 'en-GB', label: 'English (UK)' },
    { code: 'es-ES', label: 'Español (España)' },
    { code: 'es-419', label: 'Español (Latinoamérica)' },
    { code: 'fr-FR', label: 'Français' },
    { code: 'de-DE', label: 'Deutsch' },
    { code: 'it-IT', label: 'Italiano' },
];
export const CALL_LANGUAGE_CODES = CALL_LANGUAGES.map((l) => l.code);
/** Status "terminais" de uma chamada: após eles não há mais eventos do provedor. */
export const TERMINAL_CALL_STATUSES = [
    'ended',
    'failed',
    'no_answer',
    'busy',
    'voicemail',
];
/** Outcomes que justificam nova tentativa na campanha. */
export const RETRYABLE_OUTCOMES = ['no_answer', 'voicemail', 'callback'];
// ---------- Auditoria ----------
export const AUDIT_ACTIONS = [
    'create',
    'update',
    'delete',
    'import',
    'call',
    'start',
    'pause',
    'sync',
    'login',
    'login_failed',
    'logout',
    'account_locked',
    'token_reuse',
    'password_change',
    'password_reset',
    'sessions_revoked',
];
export const AUDIT_ENTITIES = [
    'email',
    'auth',
    'user',
    'role',
    'lead',
    'brand',
    'product',
    'script',
    'campaign',
    'call',
    'settings',
];
